import type { PblLawyerProfile } from '@/types/pbl';

const baseProfile = {
  full_name_en: 'John Chan',
  full_name_zh: '陳大文',
  phone: '+852 11223344',
  email: '12345@6789456123',
  hk_solicitor_admission_year: 2012,
  other_professional_qualifications: ['Qualified PRC Lawyer', 'Qualified GBA Lawyer'],
  language_proficiency: ['English', 'Cantonese', 'Mandarin'],
  law_firm_name: 'ABC Law Firm',
  law_firm_name_zh: 'ABC 律師事務所',
  position_in_law_firm: 'Partner',
  service_areas: ['estate_planning' as const, 'family_matters' as const],
  cv_publication_consent: true,
  cv_full_name_en: 'John Chan',
  cv_full_name_zh: '陳大文',
  cv_law_firm_en: 'ABC Law Firm',
  cv_law_firm_zh: 'ABC 律師事務所',
  cv_position_en: 'Partner',
  cv_position_zh: '夥伴',
  cv_admission_year_en: '2012',
  cv_admission_year_zh: '2012',
  cv_other_qualifications_en: 'Qualified PRC Lawyer, Qualified GBA Lawyer',
  cv_other_qualifications_zh: '中華人民共和國律師, 粵港澳大灣區律師',
  cv_languages_en: 'English, Cantonese, Mandarin',
  cv_languages_zh: '英語, 粵語, 普通話',
  cv_primary_practice_areas_en:
    'Estate Planning (Will, Enduring Powers of Attorney, Advance Medical Directive, etc.)',
  cv_primary_practice_areas_zh: '遺產規劃（遺囑/持久授權書/預先醫療指示）',
  cv_professional_experience_en:
    'Professional Experience Highlights - Brief description of core experience in the above practice areas. Professional Experience Highlights - Brief description of core experience in the above practice areas.',
  cv_professional_experience_zh:
    '專業經驗摘要，專業經驗摘要，專業經驗摘要，專業經驗摘要，專業經驗摘要。',
  cv_pro_bono_experience_en:
    'Pro Bono Service Experience Brief description of past pro bono / community legal service experience.',
  cv_pro_bono_experience_zh:
    '公益服務經驗，公益服務經驗，公益服務經驗，公益服務經驗，公益服務經驗。',
  cv_signature: 'John Chan',
  cv_signed_at: '2026/05/05',
  firm_authorisation_template_downloaded: true,
  firm_authorisation_file_id: 1001,
  firm_authorisation_file_name: 'signed_authorisation_form.pdf',
  firm_authorisation_confirmed: true,
  firm_authorisation_letter_attached: true,
  law_firm_change_notify_agreed: true,
  service_pledge_agreed: true,
  post_completion_agreed: true,
  pics_agreed: true,
  bankrupt_or_insolvent: true,
  arrangement_with_creditors: true,
  criminal_conviction: true,
  professional_misconduct_or_pending_disciplinary: true,
  suspended_from_professional_practice: true,
  conduct_supporting_document_file_id: 2001,
  conduct_supporting_document_names: [
    'Supporting Documents for Conduct Check01.pdf',
    'Supporting Documents for Conduct Check02.pdf',
  ],
  declaration_signature: 'John Chan',
  declaration_signed_at: '2026/05/05',
  review_confirmed: true,
};

export const fakePblLawyerApplications: PblLawyerProfile[] = [
  {
    ...baseProfile,
    id: 1,
    reference_id: 'LL-2026-000123',
    status: 'pending_review',
    created_at: '2026/04/28 04:00 PM',
    vetting_round: 1,
  },
  {
    ...baseProfile,
    id: 2,
    reference_id: 'LL-2026-000124',
    full_name_en: 'John Chan',
    full_name_zh: '陳大文',
    email: 'mary.wong@example.com',
    status: 'approved',
    created_at: '2026/04/28 04:00 PM',
    vetting_round: 1,
    reviewer_name: 'Thomas So',
  },
  {
    ...baseProfile,
    id: 3,
    reference_id: 'LL-2026-000125',
    full_name_en: 'John Chan',
    full_name_zh: '陳大文',
    email: 'alex.lee@example.com',
    status: 'resubmit_required',
    created_at: '2026/04/29 02:30 PM',
    vetting_round: 2,
    return_reason: 'Authorization letter is missing partner signature.',
    reviewer_comments: 'Please upload a properly signed Annex 1 Authorization form and confirm your current practising position.',
  },
  {
    ...baseProfile,
    id: 4,
    reference_id: 'LL-2026-000126',
    full_name_en: 'John Chan',
    full_name_zh: '陳大文',
    email: 'chris.ho@example.com',
    status: 'pending_review',
    created_at: '2026/05/01 11:15 AM',
    vetting_round: 1,
  },
  {
    ...baseProfile,
    id: 5,
    reference_id: 'LL-2026-000127',
    full_name_en: 'John Chan',
    full_name_zh: '陳大文',
    email: 'iris.lau@example.com',
    status: 'approved',
    created_at: '2026/05/02 10:05 AM',
    vetting_round: 1,
    reviewer_name: 'Thomas So',
  },
  {
    ...baseProfile,
    id: 6,
    reference_id: 'LL-2026-000128',
    status: 'resubmit_required',
    created_at: '2026/04/28 04:00 PM',
    vetting_round: 2,
    return_reason: 'Service area experience unclear',
    reviewer_comments: '',
  },
  {
    ...baseProfile,
    id: 7,
    reference_id: 'LL-2026-000129',
    status: 'approved',
    created_at: '2026/04/28 04:00 PM',
    vetting_round: 1,
    reviewer_name: 'Thomas So',
  },
  {
    ...baseProfile,
    id: 8,
    reference_id: 'LL-2026-000130',
    status: 'approved',
    created_at: '2026/04/28 04:00 PM',
    vetting_round: 1,
    reviewer_name: 'Thomas So',
  },
  {
    ...baseProfile,
    id: 9,
    reference_id: 'LL-2026-000131',
    status: 'approved',
    created_at: '2026/04/28 04:00 PM',
    vetting_round: 1,
    reviewer_name: 'Thomas So',
  },
  {
    ...baseProfile,
    id: 10,
    reference_id: 'LL-2026-000132',
    status: 'approved',
    created_at: '2026/04/28 04:00 PM',
    vetting_round: 1,
    reviewer_name: 'Thomas So',
  },
];

export const fakePblCurrentLawyerApplication = fakePblLawyerApplications[2];
